import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import { CustomerModel } from "../../../common/viewModels/Admin/CustomerModel";

@Component({
  selector: "userprofiledetails",
  templateUrl: "./userprofiledetails.component.html",
  styleUrls: ["./userprofiledetails.component.scss"],
})
export class UserProfileDetails implements OnInit {
  photo: any;
  userProfile: any;
  customers: CustomerModel[];
  roleId: any;
  userTypeId: any;

  constructor(
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.GetUserProfile();
    this.GetCustomers();
  }

  GetUserProfile() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetUserProfile).subscribe(
      (data) => {
        this._mApp.HideLoader();
        if (data.json().Result != null) {
          this.userProfile = data.json().Result;
          const currentUser = JSON.parse(localStorage.getItem("currentUser"));
          if (
            currentUser != null &&
            currentUser != "" &&
            currentUser != undefined
          ) {
            this.roleId = parseInt(currentUser.RoleId);
            this.userTypeId = parseInt(currentUser.UserTypeId);
          }
          if (data.json().Result.Image != null)
            this.photo = "data:image/jpeg;base64," + data.json().Result.Image;
          else this.photo = null;
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      },
    );
  }
  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.customers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }
}
